/**
 * @file        src/data/airports.js
 * @description Airport code to [city, full name] lookup.
 *              Ported verbatim from /Neon Bookign site Design/.
 *              Source: lines 3609–3614 of the design HTML. (The 3609–3930
 *              range in the porting brief covers helper functions surrounding
 *              this object; only the literal data is extracted here.)
 * @author      Kinetika Labs
 * @created     2026-06-22
 * @changelog
 *   - 2026-06-22 Claude — Initial.
 */

export const AIRPORTS = {
  BLR:['Bengaluru','Bengaluru Intl Arpt'], DEL:['Delhi','Delhi Indira Gandhi Intl'],
  BOM:['Mumbai','Chhatrapati Shivaji Intl'], MAA:['Chennai','Chennai Intl'],
  GOI:['Goa','Goa Intl'], HYD:['Hyderabad','Rajiv Gandhi Intl'], CCU:['Kolkata','Netaji S. C. Bose Intl'],
  PNQ:['Pune','Pune Airport'], HND:['Tokyo','Haneda Airport']
};
